import type { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useTablesStyles = makeStyles((theme: Theme) => ({
	root: {},
	heatsTable: {
		"& .ag-cell": {
			padding: "0px !important",
			textAlign: "center !important",
			fontSize: 14,
			lineBreak: "auto",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			border: "0 !important",
			wordBreak: "break-word",
		},
		"& .ag-icon-menu": {
			display: "none",
		},
		"& .ag-header-group-text ": {
			fontSize: 11,
		},
		"& .ag-header-cell": {
			fontSize: 14,
		},
		"& .ag-root-wrapper": {
			borderRadius: 3,
		},
		"& .ag-header-cell-label": {
			justifyContent: "center",
		},
		"& .max-limit": {
			color: "#CC0000",
			fontWeight: 800,
		},
	},

	agGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px 10px 50px 10px",
		minHeight: "350px",
		maxHeight: "350px", // 350px for 4 rows
	},
	middleTextfields: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px 10px 50px 10px",
		minHeight: "473px",
		maxHeight: "475px",
	},
	dynamicHeight: {
		height: (props?: { rowCount?: number }) => {
			const rowCount = props?.rowCount ?? 4; // Default to 4 if rowCount is not provided
			return `${Math.min(300 + (rowCount - 4) * 50, 550)}px`;
		},
		// 350px base for 4 rows, 50px for each additional row, maximum 550px (for 8 rows)
	},
	readonlyAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px ",
		height: "330px",
		minWidth: "100%",
		minHeight: "330px",
	},
	manualAutoButton: {
		minWidth: "5px",
		padding: "6px 8px",
		cursor: "auto",
	},
	smAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "5px",
		height: "281px",
		minHeight: "350px",
	},
	EAFAgGridBox: {
		borderRadius: "4px",
		padding: "10px",
		height: "226px",
		minHeight: "226px",
		border: "1px solid #ccc",
	},
	assetCard: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		userSelect: "none",
		height: "50px",
		marginTop: "20px",
	},
	unclassifiedDelayRow: {
		"&.ag-row": {
			backgroundColor: "#FFECEC !important",
		},
		"&.ag-row:hover": {
			backgroundColor: "#E0B0B0 !important",
		},
		"&.ag-row-selected": {
			backgroundColor: "#D8A8A8 !important",
		},
	},
	// Notes
	outlinedTextarea: {
		width: "100%",
		padding: "10px 12px",
		border: `1px solid ${theme.palette.grey[400]}`,
		borderRadius: theme.shape.borderRadius,
		fontFamily: theme.typography.fontFamily,
		fontSize: theme.typography.fontSize,
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		"&:hover": {
			borderColor: theme.palette.text.primary,
		},
		"&:focus": {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
			outline: "none",
		},
		"&::placeholder": {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
}));
